import {
  MillwrightLastFatigueWarning,
  MillwrightLastFatigueWarningApiResponse,
} from '@/apis/incidents/types/incidentsApi';

export const daysSinceLastFatigueWarningFromApiAdapter = (
  workedHours: MillwrightLastFatigueWarningApiResponse,
): MillwrightLastFatigueWarning => {
  return {
    empId: workedHours.emp_id ?? 0,
    lastWarningDate: workedHours.last_warning_date ?? '',
    daysSinceLastWarning: workedHours.days_since_last_warning ?? 0,
    riskScore: workedHours?.risk_score ? workedHours.risk_score * 100 : 0,
  };
};
